// extracted by mini-css-extract-plugin
module.exports = {"price":"VehicleTile_price__zxmbJ","year-make-model":"VehicleTile_year-make-model__VmlII"};